import { FaqSidebar } from '@/components/Faq/FaqSidebar';
import { FaucetClaimContainer } from '@/components/FaucetClaim';
import { activeChainId } from '@/common';
import { garnetHolesky } from '@/chains/garnetHolesky';
import { notFound } from 'next/navigation';
import { pyrope } from '@/chains/pyrope';

export function FaucetContainer() {
  if (activeChainId !== garnetHolesky.id && activeChainId !== pyrope.id) {
    return notFound();
  }

  return (
    <div className="flex-col lg:flex lg:h-full lg:flex-row">
      <FaucetClaimContainer />
      <FaqSidebar />
    </div>
  );
}
